// Uniforms Page
export default function Uniforms() { return <div><h1 className="text-4xl font-bold text-center py-20">Uniforms & Merchandise</h1></div>; }